<template>
    <v-row class="fill-height" align="center" justify="center" >
        <v-card>
            <v-card-title>
                <span>Logged Out</span>
            </v-card-title>
            <v-card-title>
                <span>You have been successfully logged out.</span>
            </v-card-title>
            <v-btn
                block
                color="info"
                @click="signIn()"
            >
                Login
            </v-btn> 
        </v-card>
    </v-row>
</template>

<script>
import * as auth from '@/services/auth';

export default {
    components: {

    },
    data() {
        return {
            show: true
        };
    },
    methods: {
        signIn() {
            // home page requires authentication, so going to the home page will trigger the authentication flow
            this.$router.push({ name: "home" });
        }
    }
};
</script>